import React from "react";
import "./index.scss";

import { duration } from 'utils'

// animations
import { Fade } from "react-reveal";

// images
import MainImage from "../../../assets/icons/grid.svg";

const Automated = (props) => {
  return (
    <div className="automated">
      <div className="automatedContent">
        <Fade bottom duration={duration}>
          <div className="viewImage">
            <img src={MainImage} alt="" />
          </div>
        </Fade>

        <Fade bottom duration={duration}>
          <h2>Automated yield aggregation</h2>
          <h6>An automated and passive investing strategy. </h6>
        </Fade>

        <Fade bottom duration={duration}>
          <ul>
            <li>
              Precog.finance operates in real time making it impossible for humans to
              beat PCOG to a trade
            </li>
            <li>
              Precog.finance operates 24/7 earning while you sleep, never missing an
              opportunity
            </li>

            <li>
              Precog.finance can simulate this same trading sequence simultaneously
              across thousands of assets
            </li>
            <li>
              Precog.finance can simulate this same trading sequence simultaneously
              across thousands of contracts
            </li>

            <li>
              Precog.finance can simulate this same trading sequence simultaneously
              across thousands of platforms
            </li>
          </ul>
        </Fade>
      </div>
    </div>
  );
};

export default Automated;
